import Heading from "components/Heading/Heading";
import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import HIW1img from "images/HIW1.png";
import HIW2img from "images/HIW2.png";
import HIW3img from "images/HIW3.png";
import qrtable from "images/howitwork/qr-table.gif";
import nail from "images/howitwork/nail.webp";

import book from "images/howitwork/book.gif";
import loyalty from "images/howitwork/loyalty2.png";
import VectorImg from "images/VectorHIW.svg";

export interface SectionHowItWorkProps {
  className?: string;
  data?: {
    id: number;
    title: string;
    desc: string;
    img: string;
    imgDark?: string;
  }[];
}

const DEMO_DATA: SectionHowItWorkProps["data"] = [
  {
    id: 1,
    img: qrtable,
    title: "Scan QR codr, Order & Pay",
    desc: "Digital menu: less confusion, better experience.",
  },
  {
    id: 2,
    img: nail,
    title: "Booking and Operation",
    desc: "Streamline staff bookings and auto-remind customers.",
  },

  {
    id: 4,
    img: loyalty,
    title: "Digital loyalty card",
    desc: "Convenient digital rewards that build loyalty.",
  },
  {
    id: 3,
    img: book,
    title: "Smart select the best deals",
    desc: "Better experience with AI-selected deals you’ll love.",
  },
];

const SectionHowItWork: FC<SectionHowItWorkProps> = ({
  className = "",
  data = DEMO_DATA,
}) => {
  return (
    <div
      className={`nc-SectionHowItWork  ${className}`}
      data-nc-id="SectionHowItWork"
    >
      <Heading isCenter desc="Keep calm & enjoy Lokalai services">
        How it work
      </Heading>
      <div className="mt-20 relative grid md:grid-cols-4 gap-20">
        <img
          className="hidden md:block absolute inset-x-0 top-10 rounded-xl"
          src={VectorImg}
          alt=""
        />
        {data.map((item) => (
          <div
            key={item.id}
            className="relative flex flex-col items-center max-w-xs mx-auto"
          >
            {item.imgDark ? (
              <>
                <NcImage
                  containerClassName="dark:hidden block mb-8 max-w-[200px] mx-auto rounded-xl"
                  src={item.img}
                />
                <NcImage
                  containerClassName="hidden dark:block mb-8 max-w-[200px] mx-auto rounded-xl"
                  src={item.imgDark}
                />
              </>
            ) : (
              <NcImage
                containerClassName="mb-8 max-w-[200px] mx-auto rounded-xl"
                src={item.img}
              />
            )}
            <div className="text-center mt-auto">
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
                {item.desc}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionHowItWork;
